import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  Stack, Button, Typography, Box, Link, Grid, FormControl,
  CircularProgress
}
  from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import Scrollbar from '../../../components/scrollbar/Scrollbar';
// @mui
import './styles.css';
import Iconify from '../../../components/iconify';
import { Api, UploadFile } from '../../../webservices';  
import { userdetail } from '../../../redux/slice/userSlice';  

// ----------------------------------------------------------------------

export default function SignupForm() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const token = localStorage.getItem('token');
  // console.log("token", token)
  const [value, setValue] = useState({
    "fullName": "",
    "email": "",
    "password": "",
    "contact": "",
    "DOB": "",
    "yearOfExperience": "",
    "currentCompany": "",
    "LinkedInLink": "",
    "govPhotoID": ""
  });

  const [showPassword, setShowPassword] = useState(false);
  const [uploadedImg, setUploadedImg] = useState()
  const [fileInputFiles, setFileInputFiles] = useState();
  const [dob, setDob] = useState(null); 

  const handleDateChange = (date) => {
    const formattedDate = dayjs(date)?.format('YYYY-MM-DDTHH:mm:ss[Z]');
    setDob(formattedDate);
  };
  
  // console.log("dob", dob)
  const handleFileSelect = (e) => {
    // setLoading("Please wait...")
    const file = e.target.files[0];
    setFileInputFiles(file);
    if (file) {
      uploadMulti(file);
    }
  };

  const uploadMulti = async (pdf) => {
    const token = localStorage.getItem('token');
    const formData = new FormData();
    // formData.append('document', file);
    // formData.append('directoryName', 'profile');  
    formData.append('document', pdf);
    formData.append("directoryName", "benchDocuments");
    // formData.append("resumeName", value.name);

    try {
      const response = await UploadFile('resume/upload_resume', formData, token);
      if (response.status === 200 && response.data.code === 200) {
        // const uploadedImageUrl = response.data.filePath;
        setUploadedImg(response.data.filePath)
      } else {
        //   toast.warn(response.data.status + '!');
      }
    } catch (error) {
      // toast.warn('Error uploading the image!');
    }
  };

  const [loading, setLoading] = useState(false)
  const SignUp = () => {
    // navigate('/login')
    
    if (!value.fullName) {
      toast.error("Full Name is Required");
      return;
    }
    if (!value.password) {
      toast.error("Password is Required");
      return;
    }
    if (!dob) {
      toast.error("D.O.B. is Required");
      return;
    }
    if (!value.currentCompany) {
      toast.error("Current Company is Required");
      return;
    }
    if (!value.email) {
      toast.error("Email is Required");
      return;
    }
    if (!value.contact) {
      toast.error("Contact Number is Required");
      return;
    }
    if (!value.yearOfExperience) {
      toast.error("Years of experience is Required");
      return;
    }
    if (!value.LinkedInLink) {
      toast.error("Linkedin Url is Required");
      return;
    }
    // if (!uploadedImg) {
    //   toast.error("Photo Id : Govt. Authorised");
    //   return;
    // }

    setLoading(true)
    const body =
    {
      "fullName": value.fullName,
      "email": value.email,
      "password": value.password,
      "contact": value.contact,
      "DOB": dob,
      "yearOfExperience": value.yearOfExperience,
      "currentCompany": value.currentCompany,
      "LinkedInLink": value.LinkedInLink,
      "govPhotoID": uploadedImg,
    }

    Api(`individual/signUpAccount`, 'POST', body)
      .then((response) => {
        // console.log('Response:---------', response.data.status);
        if (response.status === 200) {
          if(response.data.status === 200){
            // alert("sign")
            setValue({
              ...value,
              fullName: "",
              email: "",
              password: "",
              contact: "",
              DOB: "",
              yearOfExperience: "",
              currentCompany: "",
              LinkedInLink: "",
              govPhotoID: ""
            }) 
            toast.success(response.data?.resmessage)
            // console.log('Response:---------', response.data.resmessage);
            setTimeout(()=>{
              navigate('/login')
              setLoading(false)
            }, 3000)
          } else {
            toast.warn(response.data?.resmessage)
            setLoading(false)
          }

        } else {
          toast.warn(response.data?.resmessage)
          setLoading(false)
        }
      })
      .catch((error) => {
        // console.error("Error:", error);
      });
  };

  const handlePasswordToggle = () => {
    setShowPassword(!showPassword);
  };

  const removeLogo = () => {
    setUploadedImg('')
    setFileInputFiles('')
  }

  return (
    <>

      <Stack
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          // bgcolor: '#f4f6f8',
        }}
      >

        <Stack
          // bgcolor={'white'} 
          sx={{
            p: 5,
            mt: "100px",
            mb: 4,
            border: '2px solid #3C6BA5',
            borderRadius: 2,
            // width: '110vh',
            width: '85vh',
            maxWidth: '500vh',
            height: 'auto',
            // boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
            overflowY: 'auto',
            // bgcolor: '#3C6BA5',

          }}
        >
          <Box sx={{
            position: 'fixed',
            top: { xs: 10, sm: 24, md: 40 },
            left: { xs: 10, sm: 24, md: 40 },
          }}>
            <Link to="/" sx={{ display: 'contents' }}>
              <img alt="." src='/assets/logoBlue.svg' height={"80%"} width={"80%"} />
            </Link>
          </Box>
          <ToastContainer />
          <Scrollbar
            sx={{ Scrollbar: 'thin' }}>

            <Stack sx={{ flexDirection: 'row', justifyContent: 'center' }}>
              <Typography variant="subtitle1" sx={{ color: "#3C6BA5", mb: 3, fontSize: "20px", mt:-0.7}}>
                Create New Account
              </Typography>
            </Stack>
            <Stack spacing={2} className="email_field">

              <input
                // label="Full Name"
                color="secondary"
                placeholder="Full Name"
                name="userName"
                value={value.fullName}
                onChange={(e) => setValue({ ...value, fullName: e.target.value })}
                style={{
                  width: '100%', height: '43px', padding: '15px',
                  // background:"#959595", color:"#EFEFEF",
                  // border: "none"
                }}

              // style={{ width: '100%' }}
              />

              <input
                label="Email Id"
                color="secondary"
                placeholder="Email Id"
                type="email"
                name="email"
                value={value.email}
                onChange={(e) => setValue({ ...value, email: e.target.value })}
                style={{
                  width: '100%', height: '43px', padding: '15px',
                  // background:"#959595", color:"#EFEFEF",
                  // border: "none"
                }}
              />

              <Stack className="passwordIcon">
                <input 
                  label="Password"
                  color="secondary"
                  placeholder="Password"
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  value={value.password}
                  onChange={(e) => setValue({ ...value, password: e.target.value })}
                  style={{
                    width: '100%', height: '43px', padding: '15px',
                    // background:"#959595", color:"#EFEFEF",
                    // border: "none"
                  }}
                />
                <Iconify
                  icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'}
                  onClick={handlePasswordToggle}
                />
              </Stack>
              <input
                label="Phone Number"
                color="secondary"
                placeholder="Phone Number"
                type="number"
                value={value.contact}
                onChange={(e) => setValue({ ...value, contact: e.target.value })}
                style={{
                  width: '100%', height: '43px', padding: '15px',
                  // background:"#959595", color:"#EFEFEF", 
                  // border: "none"
                }}
              />
              {/* <input
                label="D.O.B"
                color="secondary"
                placeholder="D.O.B"
                value={value.DOB}
                onChange={(e) => setValue({ ...value, DOB: e.target.value })}

                style={{
                  width: '100%', height: '43px', padding: '15px',
                  // background:"#959595", color:"#EFEFEF",
                  // border: "none"
                }}
              /> */}
</Stack>
<Grid item sx={{ borderRadius: "5px", mt: 2, mb: 2 }}>
  <FormControl fullWidth size="small">
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        placeholder="DOB" 
        value={dob ? dayjs(dob) : null}
        onChange={handleDateChange}
        slotProps={{
          openPickerButton: { sx: {} },
          textField: {
            sx: {
              '& .MuiInputLabel-root': {
                color: "#4f4f4f", 
                height: "auto", 
                transform: 'translate(14px, 10px) scale(1)', 
                fontSize: '14px', 
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: '#dadada', 
                  borderWidth: '2px',
                  borderStyle: 'solid',
                },
                '&:hover fieldset': {
                  borderColor: '#dadada', 
                  borderWidth: '2px',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#3C6BA5', 
                  borderWidth: '2px',
                },
                '& input': {
                  backgroundColor: 'white', 
                  height: '35px', 
                  padding: '4px 12px', 
                  fontSize: '14px', 
                },
                '& input::placeholder': {
                  color: "#4f4f4f", 
                  opacity: 1, 
                },
              },
            },
          },
        }}
      />
    </LocalizationProvider>
  </FormControl>
</Grid>


<Stack spacing={2} className="email_field">

              <input
                label="Years of Experience in Recruitment Industry"
                color="secondary"
                placeholder="Years of Experience in Recruitment Industry"
                type="number"
                // name="email"
                value={value.yearOfExperience}
                onChange={(e) => setValue({ ...value, yearOfExperience: e.target.value })}
                style={{
                  width: '100%', height: '43px', padding: '15px',
                  // background:"#959595", color:"#EFEFEF",
                  // border: "none"
                }}
              />
              <input
                label="Current Company Name"
                color="secondary"
                placeholder="Current Company Name"
                // type="email"
                // name="email"
                value={value.currentCompany}
                onChange={(e) => setValue({ ...value, currentCompany: e.target.value })}
                style={{
                  width: '100%', height: '43px', padding: '15px',
                  // background:"#959595", color:"#EFEFEF",
                  // border: "none"
                }}
              />
              <input
                label="LinkedIn Profile Link"
                color="secondary"
                placeholder="LinkedIn Profile Link"
                // type="email"
                // name="email"
                value={value.LinkedInLink}
                onChange={(e) => setValue({ ...value, LinkedInLink: e.target.value })}

                style={{
                  width: '100%', height: '43px', padding: '15px',
                  // background:"#959595", color:"#EFEFEF",
                  // border: "none"
                }}
              />
              {/* <input
                label="Photo Id : Govt. Authorised"
                color="secondary"
                placeholder="Photo Id : Govt. Authorised"
                value={value.govPhotoID}
                onChange={(e) => setValue({ ...value, govPhotoID: e.target.value })}
             
                style={{
                  width: '100%', height: '43px', padding: '15px',
                  // background:"#959595", color:"#EFEFEF",
                  border: "none"
                }}
              /> */}

              {/* <Grid container sx={{ flexDirection: "row", alignItems: "center" }}>

                <Grid item>
                  <label htmlFor="file-upload" style={{ cursor: 'pointer' }}>
                    <div
                      style={{
                        border: '2px dashed black',
                        padding: '5px',
                        borderRadius: '15px',
                        // margin: '1rem',
                        marginTop: "0.7rem",
                        textAlign: 'center',
                        color: 'black',
                        width: "220px"
                      }}
                    >
                      <Typography variant="body1" fontWeight="bold" mb={1} mt={1}>
                        "Photo Id : Govt. Authorised
                      </Typography>
                      <input
                        id="file-upload"
                        type="file"
                        style={{ display: 'none' }}
                        accept="image/png, image/jpeg, image/jpg"
                        onChange={handleFileSelect}
                      />
                    </div>
                  </label>
                </Grid>

                <Grid item>
                  <Typography variant="body1" sx={{ ml: 2.5, mt: 1.8, fontSize: "16px", color: "black" }}>
                    {fileInputFiles?.name?.length > 10
                      ? `${fileInputFiles?.name?.slice(0, 35)}...`
                      : fileInputFiles?.name}
                  </Typography>

                </Grid>
                <Grid item>
                  <Typography variant="body1" sx={{ ml: 1.6, mt: 1.6, color: "green", fontSize: "16px" }}>
                    {fileInputFiles?.name ? "Success" : ''}
                  </Typography>
                </Grid>
                {fileInputFiles?.name ?
                  <Iconify sx={{ ml: 2.1, mt: 1.3, cursor: "pointer" }}
                    icon="oui:cross-in-circle-empty" color="red"
                    onClick={() => removeLogo()}
                  />
                  : ''}
              </Grid> */}

              {/* <input
        label="Confirm Password"
        color="secondary"
        placeholder="Confirm Password"
        type="password"
        name="confirmPassword"
        value={value.confirmPassword}
        onChange={handleChange}
        style={{ width: '100%', height: '43px', padding: '15px' }}
      /> */}

              <Stack alignItems={'center'}>
                <button className="login_btn1" type="submit"
                disabled={loading}
                 style={{}} onClick={() => SignUp()}>
                  {/* SIGN UP */}
                 
                     {loading ? <CircularProgress size={24} /> : 'SIGN UP'}
                         
                </button> 
              </Stack>

              <Stack sx={{ flexDirection: 'row', m: 1, justifyContent: 'center' }}>
                <Typography sx={{ }} variant="subtitle2"> Already have an account ? &nbsp;</Typography>
                <Typography color="#e3398b" sx={{ cursor: "pointer" }}
                  variant="subtitle2" onClick={() => navigate('/login')}>Login ! </Typography>
              </Stack>

            </Stack>
          </Scrollbar>
        </Stack>
      </Stack>

    </>
  );
}
